import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export interface Body {
  "scheduled-date"?: string | null;
  "scheduled-time"?: string | null;
  "scheduled-meridiem"?: string;
  "assignee-id"?: number;
  "on-site-contact-name"?: string;
  "on-site-contact-phone"?: string;
  "on-site-contact-instructions"?: string;
}

export const putInspectionSchedule = (networkHeaders: any, id: string) => (body: Body) => {
  return buildQuery(
    coreService.inspectionsScheduleUpdate(parseInt(id), { data: { attributes: body } }, { headers: networkHeaders }),
    (response) => {
      return response.data;
    },
  );
};
